import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const GponOnt = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M.763 9.622a1.558 1.558 0 0 1 1.101-.456h11.633a1.558 1.558 0 0 1 1.558 1.558v1.224a1.558 1.558 0 0 1-1.558 1.558H1.864a1.558 1.558 0 0 1-1.557-1.558v-1.224c0-.413.164-.81.456-1.102Zm1.101.21a.891.891 0 0 0-.89.892v1.224a.891.891 0 0 0 .89.891h11.633a.891.891 0 0 0 .892-.89v-1.225a.891.891 0 0 0-.892-.891H1.864Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M2.478 10.697c.184 0 .333.15.333.334v.306a.333.333 0 1 1-.666 0v-.306c0-.184.149-.334.333-.334ZM4.314 10.697c.184 0 .333.15.333.334v.306a.333.333 0 1 1-.667 0v-.306c0-.184.15-.334.334-.334ZM6.15 10.697c.184 0 .333.15.333.334v.306a.333.333 0 0 1-.667 0v-.306c0-.184.15-.334.334-.334ZM11.662 5.799c.183 0 .333.15.333.333V9.5a.333.333 0 0 1-.667 0V6.132c0-.184.15-.333.334-.333ZM8.59 2.444a5.534 5.534 0 0 1 6.142 0 .333.333 0 1 1-.37.555 4.868 4.868 0 0 0-5.402 0 .333.333 0 0 1-.37-.555Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.27 3.462a4.313 4.313 0 0 1 4.784 0 .333.333 0 1 1-.37.555 3.647 3.647 0 0 0-4.045 0 .333.333 0 0 1-.37-.555Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M9.95 4.482a3.088 3.088 0 0 1 3.426 0 .333.333 0 0 1-.37.554 2.422 2.422 0 0 0-2.687 0 .333.333 0 0 1-.37-.554ZM3.7 5.799c.185 0 .334.15.334.333V9.5a.333.333 0 0 1-.667 0V6.132c0-.184.15-.333.334-.333ZM.63 2.444a5.534 5.534 0 0 1 6.143 0 .333.333 0 0 1-.37.555 4.868 4.868 0 0 0-5.402 0 .333.333 0 1 1-.37-.555Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M1.309 3.462a4.313 4.313 0 0 1 4.784 0 .333.333 0 1 1-.37.555 3.646 3.646 0 0 0-4.045 0 .333.333 0 0 1-.37-.555Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M1.986 4.481a3.089 3.089 0 0 1 3.432 0 .333.333 0 1 1-.37.555 2.422 2.422 0 0 0-2.692 0 .333.333 0 0 1-.37-.555ZM8.628 11.057v.558h3.925v-.558H8.628Zm3.952-.333v-.333h.015a.627.627 0 0 1 .088.009c.05.008.123.026.2.064a.602.602 0 0 1 .337.566v.612h-.334.334v.015a.608.608 0 0 1-.01.088.71.71 0 0 1-.064.2.602.602 0 0 1-.566.337H8.6v-.334.334h-.014a.625.625 0 0 1-.088-.01.71.71 0 0 1-.2-.064.602.602 0 0 1-.337-.566v-.612h.333-.333v-.014a.574.574 0 0 1 .01-.089.71.71 0 0 1 .063-.2.602.602 0 0 1 .566-.336h3.98v.333ZM2.478 12.84c.184 0 .333.15.333.333v.918a.333.333 0 1 1-.666 0v-.918c0-.184.149-.333.333-.333ZM12.886 12.84c.184 0 .333.15.333.333v.918a.333.333 0 1 1-.666 0v-.918c0-.184.149-.333.333-.333Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

GponOnt.category = 'product-category';

GponOnt.displayName = 'GponOnt';
